import React, { useState, useEffect } from 'react';
import './styles.css';
// index.js または App.js
import "academicons/css/academicons.min.css";


const LlamaMimiPage = () => {
  return (
    <div className="page">

      {/* Header */}
      <div className="header">
        <h1>
          Jagle: Building a Large-Scale Japanese Multimodal Post-Training Dataset for Vision-Language Models
        </h1>
        <div className="authors">
          <span><a href="#">Issa Sugiura</a><sup>1,2</sup></span>
          <span><a href="#">Keito Sasagawa</a><sup>3,2</sup></span>
          <span><a href="#">Keisuke Nakao</a><sup>3,2</sup></span>
          <span><a href="#">Koki Maeda</a><sup>4,2</sup></span>
          <span><a href="#">Ziqi Yin</a><sup>2</sup></span>
          <span><a href="#">Zhishen Yang</a><sup>2</sup></span>
          <span><a href="#">Shuhei Kurita</a><sup>5,2</sup></span>
          <span><a href="#">Yusuke Oda</a><sup>2</sup></span>
          <span><a href="#">Ryoko Tokuhisa</a><sup>6,7</sup></span>
          <span><a href="#">Daisuke Kawahara</a><sup>3,2</sup></span>
          <span><a href="#">Naoaki Okazaki</a><sup>4,2</sup></span>
        </div>
        <div className="affiliations">
          <sup>1</sup>Kyoto University, <sup>2</sup>NII LLMC, <sup>3</sup>Waseda University, <sup>4</sup>Institute of Science Tokyo <sup>5</sup>NII, <sup>6</sup>Aichi Institute of Technology, <sup>7</sup>Institute of Physical and Chemical Research
        </div>
        <div className="links">
                  <a
  href="https://arxiv.org/abs/2604.02048"
  className="btn"
>
  <i className="ai ai-arxiv ai-lg"></i>
  <span>arXiv</span>
          </a>
          <a href="https://huggingface.co/datasets/llm-jp/Jagle" className="btn">🤗 Dataset</a>
          <a href="https://huggingface.co/collections/llm-jp/jagle" className="btn">🤗 Models</a>
          <a
  href="https://github.com/llm-jp/llm-jp-4-vl"
  className="btn"
  >
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ marginRight: "8px" }}
  >
    <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.1 3.29 9.42 7.86 10.96.58.1.79-.25.79-.56
    0-.28-.01-1.02-.02-2-3.2.7-3.88-1.54-3.88-1.54-.53-1.36-1.29-1.72-1.29-1.72-1.05-.72.08-.7.08-.7
    1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.72-1.55-2.55-.29-5.23-1.28-5.23-5.7
    0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.15 1.18A10.9 10.9 0 0112 6.8c.97.01 1.95.13
    2.87.38 2.18-1.49 3.14-1.18 3.14-1.18.62 1.58.24 2.75.12 3.04.73.81 1.18 1.83 1.18 3.09
    0 4.43-2.68 5.41-5.24 5.7.41.36.77 1.08.77 2.18
    0 1.57-.01 2.83-.01 3.21 0 .31.21.67.79.56A10.52 10.52 0 0023.5 12C23.5 5.73 18.27.5 12 .5z"/>
  </svg>
  Code
          </a>
          <a href="https://speed1313.github.io/posts/Jagle" className="btn">📝 Blog</a>
        </div>
      </div>

          {/* Abstract */}
      <div className="section">
        <h2 className="section-title">Abstract</h2>
        <div className="prose">
          <p>
            Developing vision-language models (VLMs) that generalize across diverse tasks requires large-scale training datasets with diverse content. In English, such datasets are typically constructed by aggregating and curating numerous existing visual question answering (VQA) resources. However, this strategy does not readily extend to other languages, where VQA datasets remain limited in both scale and domain coverage, posing a major obstacle to building high-quality multilingual and non-English VLMs.
            In this work, we introduce Jagle, the largest Japanese multimodal post-training dataset to date, comprising approximately 9.2 million instances across diverse tasks. Rather than relying on existing VQA datasets, we collect heterogeneous source data, including images, image-text pairs, and PDF documents, and generate VQA pairs through multiple strategies such as VLM-based QA generation, translation, and text rendering.
            Experiments demonstrate that a 2.2B model trained with Jagle achieves strong performance on Japanese tasks, surpassing InternVL3.5-2B in average score across ten Japanese evaluation tasks and approaching within five points of Qwen3-VL-2B-Instruct. Furthermore, combining Jagle with FineVision does not degrade English performance; instead, it improves English performance compared to training with FineVision alone.
            To facilitate reproducibility and future research, we release the dataset, trained models, and code.
          </p>
        </div>
      </div>

      <div className="section bg-gray">
        <div className="teaser">
          <div className="teaser-box">
            <img src={`${process.env.PUBLIC_URL}/data/jagle-construction-pipeline.svg`} alt="Construction pipeline of Jagle" />
          </div>
          <p>
            Construction pipeline of Jagle. Our pipeline leverages diverse data sources,
including images, image-text pairs, and PDF corpora, and integrates multiple QA generation
strategies such as VLM-based QA generation, translation, OCR-based text extraction, text
rendering, and direct utilization of existing data to produce VQA samples.
          </p>
        </div>
      </div>


          {/* Teaser - Scrollable Results */}
      <div className="section bg-gray">
        <h2 className="section-title">Figures</h2>
        <div className="scrollable-container">
          <div className="scroll-content">
            <div className="result-item">
              <div className="result-image">
                <img src={`${process.env.PUBLIC_URL}/data/piechart_4metrics.svg`} alt="Category distribution of Jagle" />
              </div>
              <p className="result-caption">
                <strong>Category distribution of Jagle across four metrics: number of samples, unique images, turns, and answer tokens.</strong>
              </p>
            </div>
            <div className="result-item">
              <div className="result-image">
                <img src={`${process.env.PUBLIC_URL}/data/samples.svg`} alt="VQA examples from Jagle" />
              </div>
              <p className="result-caption">
                <strong>Representative VQA examples from each category in Jagle. The dataset covers a wide variety of visual content, including natural images, charts and tables, document images, and presentation slides.</strong>
              </p>
            </div>
            <div className="result-item">
              <div className="result-image">
                <img src={`${process.env.PUBLIC_URL}/data/training_curve_avg.svg`} alt="Training curve" />
              </div>
              <p className="result-caption">
                <strong>Training dynamics under each data setting for the macro-averaged score over all 21 tasks (Avg), 10 Japanese tasks (JA Avg), and 10 English tasks (EN Avg). The model trained on Jagle outperforms the model trained on FineVision by over 20 points on JA Avg.</strong>
              </p>
            </div>
          </div>
          <div className="scroll-indicator">
            <span>← Scroll for more results →</span>
          </div>
        </div>
      </div>



 {/* Results Table */}
      {/* <div className="section">
        <h2 className="section-title">Evaluation Results</h2>
        <div className="table-container">
          <table className="results-table">
            <thead>
              <tr>
                <th>Model</th>
                <th>Params</th>
                <th colSpan="1">Retrieval</th>
                <th colSpan="3">Image Classification</th>
                <th>Avg</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th>XM3600<sub>ja</sub></th>
                <th>ImageNet<sub>ja</sub></th>
                <th>Recruit</th>
                <th>WAON-Bench</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr className="highlight-row">
                <td><a href="https://huggingface.co/llm-jp/waon-siglip2-base-patch16-256">siglip2-base-patch16-256 (fine-tuned on WAON)</a></td>
                <td>375M</td>
                <td>73.75</td>
                <td>49.61</td>
                <td><strong>83.14</strong></td>
                <td><strong>94.97</strong></td>
                <td><strong>75.37</strong></td>
              </tr>
              <tr>
                <td>siglip2-base-patch16-256 (fine-tuned on ReLAION)</td>
                <td>375M</td>
                <td>72.39</td>
                <td>47.38</td>
                <td>81.65</td>
                <td>92.99</td>
                <td>73.60</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/google/siglip2-base-patch16-256">google/siglip2-base-patch16-256</a></td>
                <td>375M</td>
                <td>38.28</td>
                <td>48.12</td>
                <td>76.98</td>
                <td>87.81</td>
                <td>62.80</td>
              </tr>
              <tr className="separator-row">
                <td colSpan="7"></td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/line-corporation/clip-japanese-base">clip-japanese-base</a></td>
                <td>196M</td>
                <td><strong>78.00</strong></td>
                <td>48.90</td>
                <td>81.65</td>
                <td>90.05</td>
                <td>74.65</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/google/siglip-base-patch16-256-multilingual">siglip-base-patch16-256-mult</a></td>
                <td>371M</td>
                <td>43.22</td>
                <td>53.26</td>
                <td>75.10</td>
                <td>89.25</td>
                <td>65.21</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/stabilityai/japanese-stable-clip-vit-l-16">Japanese Stable CLIP ViT-L-16</a></td>
                <td>414M</td>
                <td>66.03</td>
                <td><strong>55.97</strong></td>
                <td>71.29</td>
                <td>82.03</td>
                <td>68.83</td>
              </tr>
              <tr>
                <td><a href="https://huggingface.co/laion/CLIP-ViT-H-14-frozen-xlm-roberta-large-laion5B-s13B-b90k">LAION-CLIP-ViT-H-14</a></td>
                <td>1193M</td>
                <td>72.64</td>
                <td>47.67</td>
                <td>70.62</td>
                <td>85.88</td>
                <td>69.20</td>
              </tr>
            </tbody>
          </table>
          <p className="table-caption">
            Performance of models on each dataset. Fine-tuning <a href="https://huggingface.co/google/siglip2-base-patch16-256">google/siglip2-base-patch16-256</a> on the WAON dataset achieves state-of-the-art performance on the Japanese cultural benchmarks, Recruit and WAON-Bench. Using WAON consistently yields higher performance across all benchmark datasets compared to fine-tuning on ReLAION (ja subset).
          </p>
        </div>
      </div> */}

      {/* BibTeX */}
      <div className="section bg-gray">
        <div className="bibtex-header">
          <h2 className="section-title">BibTeX</h2>
          <button
            className="btn"
            onClick={() => {
              const bibtex = `@misc{sugiura2026jaglebuildinglargescalejapanese,
      title={Jagle: Building a Large-Scale Japanese Multimodal Post-Training Dataset for Vision-Language Models},
      author={Issa Sugiura and Keito Sasagawa and Keisuke Nakao and Koki Maeda and Ziqi Yin and Zhishen Yang and Shuhei Kurita and Yusuke Oda and Ryoko Tokuhisa and Daisuke Kawahara and Naoaki Okazaki},
      year={2026},
      eprint={2604.02048},
      archivePrefix={arXiv},
      primaryClass={cs.CV},
      url={https://arxiv.org/abs/2604.02048},
}`;
              navigator.clipboard.writeText(bibtex);
              alert('BibTeX copied to clipboard!');
            }}
          >
            📋 Copy
          </button>
        </div>
        <pre className="bibtex-code">
{`@misc{sugiura2026jaglebuildinglargescalejapanese,
      title={Jagle: Building a Large-Scale Japanese Multimodal Post-Training Dataset for Vision-Language Models},
      author={Issa Sugiura and Keito Sasagawa and Keisuke Nakao and Koki Maeda and Ziqi Yin and Zhishen Yang and Shuhei Kurita and Yusuke Oda and Ryoko Tokuhisa and Daisuke Kawahara and Naoaki Okazaki},
      year={2026},
      eprint={2604.02048},
      archivePrefix={arXiv},
      primaryClass={cs.CV},
      url={https://arxiv.org/abs/2604.02048},
}`}
        </pre>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>
          This page was built using the <a href="https://github.com/eliahuhorwitz/Academic-project-page-template">Academic Project Page Template</a>...<br />
          This website is licensed under a <a href="http://creativecommons.org/licenses/by-sa/4.0/">CC BY-SA 4.0</a>.
        </p>
      </footer>
    </div>
  );
};

export default LlamaMimiPage;
